import { Box, TextField, Typography } from '@mui/material'
import { IFilterComponentProps } from 'components/Table/TableFilter/types'
import { NumberRegexp } from 'components/Table/TableFilter/utils'
import { useState } from 'react'
import styled from '@emotion/styled'
import { ClickAwayListener } from '@mui/base/ClickAwayListener'
import {
  inputStyles,
  rangeFilterContainer,
  rangeInputStyles,
  rangePickersContainer,
} from '../Inputs.style'

const Text = styled(Typography)`
  font-size: 12px;
  span {
    font-weight: 600;
  }
`

function RangeFilterInput({
  value,
  columnId,
  handleFilterState,
  startAdornment,
  filterType,
}: IFilterComponentProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true)

  const setFrom = (startDate) => {
    if (startDate === '' || NumberRegexp.test(startDate)) {
      handleFilterState(columnId, filterType, [startDate, value?.[1]])
    }
  }

  const setTo = (endDate) => {
    if (endDate === '' || NumberRegexp.test(endDate)) {
      handleFilterState(columnId, filterType, [value?.[0], endDate])
    }
  }

  return (
    <ClickAwayListener
      onClickAway={() => {
        setIsOpen(false)
      }}
    >
      <Box sx={rangeFilterContainer}>
        {isOpen ? (
          <Box sx={rangePickersContainer}>
            <TextField
              fullWidth
              value={value?.[0] || ''}
              onChange={(e) => setFrom(e.target.value)}
              variant="standard"
              placeholder="Start"
              sx={rangeInputStyles}
            />
            <TextField
              fullWidth
              value={value?.[1] || ''}
              onChange={(e) => setTo(e.target.value)}
              variant="standard"
              placeholder="end"
              inputProps={{
                p: '0px 5px',
              }}
              sx={rangeInputStyles}
            />
          </Box>
        ) : (
          <TextField
            fullWidth
            variant="standard"
            onClick={() => setIsOpen(true)}
            InputProps={{ startAdornment }}
            value={`${value?.[0] ?? '-'}-${value?.[1] ?? '-'}`}
            sx={inputStyles}
          />
        )}
      </Box>
    </ClickAwayListener>
  )
}

export default RangeFilterInput
